// Module
var code = `<div data-bind="css: cssClasses">
  <div class="svc-row__drop-indicator svc-row__drop-indicator--top"></div>
  <div class="svc-row__drop-indicator svc-row__drop-indicator--bottom"></div>
  <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
  <!-- /ko -->
</div>
`;
// Exports
export default code;